import { Typography } from "@mui/material";
import { T } from "../../util/t";

export const AthleteOrTeamHeader = ({ className, config }) =>
    <Typography className={className} variant="label2" color="textSecondary">
        {config.isTeams ? <T>Team</T> : <T>Athlete</T>}
    </Typography>;
